import { render } from "./RegistNoRequest.vue?vue&type=template&id=280cf0d6&scoped=true"
import script from "./RegistNoRequest.vue?vue&type=script&lang=js"
export * from "./RegistNoRequest.vue?vue&type=script&lang=js"

import "./RegistNoRequest.vue?vue&type=style&index=0&id=280cf0d6&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-280cf0d6"]])

export default __exports__